import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../actions/storeActions";
import Loading from "../../helpers/Loading";
import Items from "./Items";
var countDownTimer;
const Dishes = () => {
  const [dishes, setDishes] = useState(null);

  const dispatch = useDispatch();
  const table_data = useSelector((state) => state.messageDetail);
  const [tag, setTag] = useState({ time: null, name: null });
  const [time, setTime] = useState({
    days: null,
    hours: null,
    minutes: null,
    seconds: null,
  });
  function timer(timestamps) {
    //time converted
    const countDown = new Date(timestamps).getTime();

    countDownTimer = setInterval(() => {
      const now = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Manila" })
      ).getTime();
      const distance = countDown - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        setTag({ name: "Today's Menu", time: false });
        clearInterval(countDownTimer);
        // dispatch({ type: "LOGOUT" });
        // setSession({ time: false });
        setTime({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });
      } else if (minutes >= 0 && seconds >= 0 && hours >= 0) {
        setTag({ name: "Tomorrow's Menu", time: true });
        setTime({
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds,
        });
      }
    }, 1000);
  }
  useEffect(() => {
    (async function getDailyDishes() {
      const {
        data: { dish, goods, timestamps },
      } = await getProducts();
      setDishes(dish);

      dispatch({
        type: "TABLE_DATA_WITH_MESSAGE_STATUS",
        payload: { dish: dish, goods: goods },
      });
      timer(timestamps);
    })();
  }, []);

  if (table_data.table_data?.dish == null) return <Loading />;
  return (
    <div className="sale_item_body">
      <div className="row align sale_item_header">
        <h3 className="header_title">Daily Dishes </h3>
        <p className={tag.time ? "tag orange" : "tag cyan"}>{tag.name}</p>
        {tag.time === true && (
          <p>
            Serving in
            {` ${time.days}d : ${time.hours}h : ${time.minutes}m : ${time.seconds}s `}
          </p>
        )}
      </div>
      <div className="sale_item_container">
        <ul className="sale_item_list">
          {table_data.table_data.dish.map((data) => {
            const { status, _id } = data;
            return (
              <React.Fragment key={_id}>
                {status === "Display" && <Items data={data} />}
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Dishes;
